import { Stylesheet } from "@fluentui/react/lib/Styling"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { MemoryRouter } from "react-router-dom"

import {
    ComponentName,
    registerDefaultApplicationComponents
} from "@encoway/cui-application-components"
import { registerDefaultConfiguratorComponents } from "@encoway/cui-configurator-components"

import { App } from "./App"
import startSessionTracking from "./app/sessionRegister"
import { initCatalogService } from "./app/catalogServiceHolder"
import { store } from "./app/store"
import { WagoVisualization } from "./components/WagoVisualization"
import { initializeLanguage } from "./utils/languageService"
import { initializeTranslations } from "./utils/translationService"

window.encoway = {
    baseUrl: window.encoway.baseUrl || "",
    initialized: false,
    startConfiguration: async (
        productId: string,
        elementId: string
    ): Promise<void> => {
        if (window.encoway.baseUrl === "") {
            console.error(
                "Configuration cannot be started! No base url is set!"
            )
            return
        }
        if (!window.encoway.initialized) {
            registerDefaultApplicationComponents().override(
                ComponentName.Visualization,
                WagoVisualization
            )
            registerDefaultConfiguratorComponents()

            Stylesheet.getInstance().setConfig({ namespace: "encoway" })

            window.encoway.initialized = true
        }

        await initCatalogService()
        await initializeLanguage()
        await initializeTranslations()
        startSessionTracking()

        const container = document.getElementById(elementId)
        if (container !== null) {
            ReactDOM.unmountComponentAtNode(container)
        }

        ReactDOM.render(
            <Provider store={store}>
                <MemoryRouter>
                    <App productId={productId} />
                </MemoryRouter>
            </Provider>,
            document.getElementById(elementId)
        )
    }
}
